import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56c8fc26"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pool-info stretch-height"
}
const _hoisted_2 = { class: "small-nav" }
const _hoisted_3 = {
  key: 0,
  class: "pool-info-map fill"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "fill"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"location-list\" data-v-56c8fc26><div class=\"num\" data-v-56c8fc26>#</div><div class=\"name\" data-v-56c8fc26>Place</div><div class=\"lat\" data-v-56c8fc26>Latitude</div><div class=\"lng\" data-v-56c8fc26>Longitude</div></div>", 1)
const _hoisted_8 = { class: "num" }
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "lat" }
const _hoisted_11 = { class: "lng" }
const _hoisted_12 = {
  key: 1,
  class: "blocker"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Locations are not applicable to this drop pool", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_mapbox_geocoder_control = _resolveComponent("mapbox-geocoder-control")!
  const _component_mapbox_marker = _resolveComponent("mapbox-marker")!
  const _component_mapbox_map = _resolveComponent("mapbox-map")!
  const _component_Scroller = _resolveComponent("Scroller")!
  const _component_UpdateCreateDropLocationForm = _resolveComponent("UpdateCreateDropLocationForm")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_vue_csv_errors = _resolveComponent("vue-csv-errors")!
  const _component_vue_csv_input = _resolveComponent("vue-csv-input")!
  const _component_vue_csv_map = _resolveComponent("vue-csv-map")!
  const _component_vue_csv_import = _resolveComponent("vue-csv-import")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.selectedDropPool)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createVNode(_component_a_tooltip, {
                title: "Locations on Map",
                placement: "right"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.section = 'map')),
                    size: "small",
                    class: "small-nav-btn"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, { icon: "map-marker-alt" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_a_tooltip, {
                title: "Locations list",
                placement: "right"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.section = 'list')),
                    size: "small",
                    class: "small-nav-btn"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, { icon: "list" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_a_tooltip, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showCSVModal = true)),
                title: "Upload csv file",
                placement: "right"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    size: "small",
                    class: "small-nav-btn"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, { icon: "upload" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_a_tooltip, {
                title: "Delete all locations",
                placement: "right"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    size: "small",
                    class: "small-nav-btn"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "trash",
                        onClick: _ctx.deleteAllLocation
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          (_ctx.section == 'map')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_mapbox_map, {
                  accessToken: 
					'pk.eyJ1IjoiY2hyaXMtZ3JlZW4iLCJhIjoiY2t0Z2F3M2M1MGdkbDMwcGU3MGZueXpwOSJ9.ONbWrh7EhHzErxjapxkVgg'
				,
                  mapStyle: "mapbox://styles/chris-green/ckv82iwz96fmu15mphxtyncnv",
                  onClick: _ctx.addDroplocation
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_mapbox_geocoder_control, {
                      onResult: _ctx.gotoDropLocation,
                      marker: false
                    }, null, 8, ["onResult"]),
                    (_ctx.selectedDropPool.dropLocations.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedDropPool.dropLocations, (dropLocation, index) => {
                            return (_openBlock(), _createBlock(_component_mapbox_marker, {
                              lngLat: [
							dropLocation.longitude,
							dropLocation.latitude
						],
                              key: index,
                              draggable: true,
                              onClick: ($event: any) => (_ctx.onUpdate(index)),
                              onDragend: ($event: any) => (_ctx.dragMarker($event, index))
                            }, null, 8, ["lngLat", "onClick", "onDragend"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["accessToken", "onClick"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.section == 'list')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.selectedDropPool.dropLocations.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, " No drop locations added "))
                  : _createCommentVNode("", true),
                _hoisted_7,
                _createVNode(_component_Scroller, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedDropPool.dropLocations, (location, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "location-list",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(index + 1) + ".", 1),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(location.placeName), 1),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(location.latitude), 1),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(location.longitude), 1)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedDropPool && _ctx.selectedDropPool.dropType !== 'gps')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      footer: null,
      visible: _ctx.showModal,
      title: `${_ctx.method} Drop Location`,
      onCancel: _ctx.closeModal
    }, {
      default: _withCtx(() => [
        (_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_UpdateCreateDropLocationForm, {
                method: _ctx.method,
                index: _ctx.locationIndex,
                dropLocation: _ctx.dropLocation,
                dropPool: _ctx.selectedDropPool,
                onDone: _ctx.closeModal
              }, null, 8, ["method", "index", "dropLocation", "dropPool", "onDone"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "title", "onCancel"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.showCSVModal,
      title: `Upload CSV Locations`,
      onCancel: _ctx.closeModal,
      onOk: _cache[4] || (_cache[4] = ($event: any) => (_ctx.createDropLocationsFromCSV()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vue_csv_import, {
          modelValue: _ctx.csv,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.csv) = $event)),
          modelModifiers: { value: true },
          fields: {
				placeName: { required: true, label: 'Place Name' },
				latitude: { required: true, label: 'Latitude' },
				longitude: { required: true, label: 'Longitude' }
			},
          class: "upload-style"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_vue_csv_errors),
            _createVNode(_component_vue_csv_input),
            _createVNode(_component_vue_csv_map)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["visible", "onCancel"])
  ], 64))
}